import { catchAxiosErr } from "utils/catchAxiosError";
import axios from "axios";

export const getUserDetails = async () => {
  try {
    const res = await axios.get("/users/self");
    return res.data;
  } catch (err) {
    return catchAxiosErr(err);
  }
};
